import { render, staticRenderFns } from "./hotmap.vue?vue&type=template&id=da40a236&scoped=true&"
import script from "./hotmap.vue?vue&type=script&lang=js&"
export * from "./hotmap.vue?vue&type=script&lang=js&"
import style0 from "./hotmap.vue?vue&type=style&index=0&id=da40a236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da40a236",
  null
  
)

export default component.exports